(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.scrollThreshold = 8;
      this.revealAfter = 80;
      this.ticking = false;

      this.setHeaderHeight();

      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.header.classList.add('ouzza-header-visible');
      this.header.classList.remove('ouzza-header-hidden');
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;

      window.requestAnimationFrame(() => {
        const currentScrollTop = Math.max(
          0,
          window.pageYOffset || document.documentElement.scrollTop || 0
        );

        const delta = currentScrollTop - this.lastScrollTop;

        if (currentScrollTop <= 4) {
          this.showHeader();
        } else if (Math.abs(delta) >= this.scrollThreshold) {
          if (delta > 0 && currentScrollTop > this.revealAfter) {
            this.hideHeader();
          } else if (delta < 0) {
            this.showHeader();
          }
        }

        this.lastScrollTop = currentScrollTop;
        this.ticking = false;
      });
    }

    hideHeader() {
      if (!this.header) return;

      this.header.classList.add('ouzza-header-hidden');
      this.header.classList.remove('ouzza-header-visible');

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    showHeader() {
      if (!this.header) return;

      this.header.classList.remove('ouzza-header-hidden');
      this.header.classList.add('ouzza-header-visible');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
